import EVENT from '../enums/event.js';
import Product from '../models/Product.js';

const getProductsInWishlist = swat => {
  window.productsInWishlist = [];

  swat.fetchWrtEventTypeET(response => {
    response.forEach(product => {
      window.productsInWishlist[product.empi] = Product.fromSwym(product);
    });

    document.dispatchEvent(
      new CustomEvent(EVENT.WISHLIST.CONTENTS_LOADED, {
        detail: {
          products: window.productsInWishlist,
        },
      })
    );
  }, swat.EventTypes.addToWishList);
};

export default getProductsInWishlist;
